require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./baseinput"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./baseinput"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./baseinput")) : factory(root["./utils"], root["./baseinput"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__33__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[63],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__33__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(523);


/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TextInput = _interopRequireDefault(__webpack_require__(524));

exports["default"] = _TextInput["default"];
exports.TextInput = _TextInput["default"];

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baUiCarbon = __webpack_require__(12);

var _utils = __webpack_require__(4);

var _baseinput = _interopRequireDefault(__webpack_require__(33));

var _StringResource = _interopRequireDefault(__webpack_require__(525));

var _TextInput = _interopRequireDefault(__webpack_require__(527));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize,
    getInheritedProps = _utils.propsUtils.getInheritedProps;

var _CLASS = _TextInput["default"].textInputClassName.replace(/"/g, ''); // accept only a valid string as input


var fixupValue = function fixupValue(value, _ref) {
  var type = _ref.type;

  if (type === 'password' || value === undefined) {
    return undefined;
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string') {
    return value;
  }

  return '';
}; // check value; and return a bound value and message when applicable


var checkValue = function checkValue(value, _ref2) {
  var allowEmpty = _ref2.allowEmpty;

  if ((value != null ? value : '') === '') {
    if (allowEmpty) {
      return {
        value: '',
        message: undefined
      };
    }

    return {
      value: undefined,
      message: _StringResource["default"].get('empty')
    };
  }

  return {
    value: value,
    message: undefined
  };
};

var TextInput = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TextInput, _Component);

  function TextInput(_props) {
    var _this;

    _this = _Component.call(this, _props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_useOnValueCallbacks", !!_this.props.onValueChange || !!_this.props.onValueAccept);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (input) {
      _this._input = input;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueChange", function (newValue) {
      var onValueChange = _this.props.onValueChange;

      var _checkValue = checkValue(newValue, _this.props),
          value = _checkValue.value,
          message = _checkValue.message;

      _this.setState({
        displayValue: newValue,
        message: message
      }); // if the input is or can be valid


      if (value !== undefined) {
        // if there is additional processing, call it
        onValueChange && onValueChange(value, newValue);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (newValue, finalFireOnBlur) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          fireOnBlur = _this$props.fireOnBlur,
          value = _this$props.value;

      _this.setState({
        displayValue: finalFireOnBlur ? value : newValue
      });

      (!fireOnBlur || finalFireOnBlur && newValue !== value) && (onChange == null ? void 0 : onChange(newValue));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onBlur", function (e) {
      var _this$props2 = _this.props,
          onBlur = _this$props2.onBlur,
          value = _this$props2.value,
          fireOnBlur = _this$props2.fireOnBlur;

      _this.setState({
        displayValue: value
      });

      fireOnBlur && _this._onChange(e.currentTarget.value, true);
      onBlur == null ? void 0 : onBlur(e);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onValueAccept", function (newValue) {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          onValueAccept = _this$props3.onValueAccept;
      var oldValue = fixupValue(value, _this.props);

      var _checkValue2 = checkValue(newValue, _this.props),
          newBoundValue = _checkValue2.value;

      var _checkValue3 = checkValue(oldValue, _this.props),
          oldBoundValue = _checkValue3.value,
          message = _checkValue3.message;

      _this.setState({
        displayValue: oldValue,
        message: message
      }); // check if the old value does not match the new bound value


      if (oldBoundValue !== newBoundValue) {
        // if there is additional processing, call it
        onValueAccept && onValueAccept(newBoundValue, newValue);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputToRender", function (props) {
      return (
        /*#__PURE__*/
        // eventually/hopefully the props sent via BaseInput can be done directly here
        _react["default"].createElement(_baUiCarbon.TextInput, props)
      );
    });
    _this.state = {
      displayValue: undefined,
      message: undefined
    };
    return _this;
  } // eventually/hopefully onValueChange/onValueAccept will be the norm, and useOnValueCallbacks can be removed


  var _proto = TextInput.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var value = this.props.value;
    var fixedNewValue = fixupValue(value, this.props);

    var _checkValue4 = checkValue(fixedNewValue, this.props),
        message = _checkValue4.message;

    this.setState({
      displayValue: fixedNewValue,
      message: message
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(_ref3) {
    var newValue = _ref3.value;
    var oldValue = this.props.value;
    var fixedOldValue = fixupValue(oldValue, this.props);
    var fixedNewValue = fixupValue(newValue, this.props);

    var _checkValue5 = checkValue(fixedNewValue, this.props),
        message = _checkValue5.message; // this.setState({ message });


    if (fixedNewValue !== fixedOldValue) {
      this.setState({
        displayValue: fixedNewValue,
        message: message
      });
    }
  };

  _proto.focus = function focus() {
    var disabled = this.props.disabled;
    !disabled && this._input && this._input.focus();
  };

  _proto.render = function render() {
    // extract props that are to be manipulated or not passed down
    var _this$props4 = this.props,
        inputChildren = _this$props4.inputChildren,
        type = _this$props4.type,
        dir = _this$props4.dir,
        textDir = _this$props4.textDir,
        className = _this$props4.className,
        validationErrorText = _this$props4.validationErrorText,
        hasValidationError = _this$props4.hasValidationError,
        onChange = _this$props4.onChange,
        onBlur = _this$props4.onBlur,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["inputChildren", "type", "dir", "textDir", "className", "validationErrorText", "hasValidationError", "onChange", "onBlur"]);
    var _this$state = this.state,
        displayValue = _this$state.displayValue,
        message = _this$state.message;
    var mappedMessage = this._useOnValueCallbacks && message ? message : undefined;
    return (
      /*#__PURE__*/
      // ideally baseInput is only a temporary wrapper to handle error handling
      // as such the only props that should need to be sent to it are those dealing with message handling
      _react["default"].createElement(_baseinput["default"], (0, _extends2["default"])({
        inputToRender: this._inputToRender,
        className: _CLASS + " " + className,
        "data-tid": _CLASS
      }, sanitize(others, TextInput), getInheritedProps(others, _baseinput["default"]), {
        ref: this._ref
      }, dir ? {
        dir: dir
      } : {}, textDir ? {
        textDir: textDir
      } : {}, {
        value: displayValue,
        children: inputChildren,
        onBlur: this._useOnValueCallbacks ? onBlur : this._onBlur,
        onChange: this._useOnValueCallbacks ? onChange : this._onChange,
        onValueChange: this._useOnValueCallbacks ? this._onValueChange : undefined,
        onValueAccept: this._useOnValueCallbacks ? this._onValueAccept : undefined,
        validationErrorText: mappedMessage || validationErrorText,
        hasValidationError: mappedMessage ? true : hasValidationError,
        type: type != null ? type : 'text'
      }))
    );
  };

  return TextInput;
}(_react.Component);

exports["default"] = TextInput;
(0, _defineProperty2["default"])(TextInput, "propTypes", (0, _extends2["default"])({}, _baseinput["default"].propTypes, {
  // these props have a different definition then the baseInput props
  type: _propTypes["default"].oneOf(['password']),
  value: _propTypes["default"].oneOfType([_propTypes["default"].string]),
  // these props are in addition to the baseInput props
  inputChildren: _propTypes["default"].node
}));
(0, _defineProperty2["default"])(TextInput, "defaultProps", {
  className: '',
  style: {},
  allowEmpty: true
});

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _TextInputResources = _interopRequireDefault(__webpack_require__(526));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
// eslint-disable-line
var _default = new _utils.StringResource(_TextInputResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 526:
/***/ (function(module, exports) {

var amdi18n={"__root":{"empty":"Enter a string.","max":"Enter a string that contains %{value} or less characters.","min":"Enter a string that contains at least %{value} characters.","trimStart":"Enter a string that begins with a non-whitespace character.","trimEnd":"Enter a string that ends with a non-whitespace character."},"__cs":{"empty":"Zadejte platný řetězec.","max":"Zadejte řetězec, který obsahuje %{value} nebo méně znaků.","min":"Zadejte řetězec, který obsahuje alespoň %{value} znaků.","trimStart":"Zadejte řetězec, který začíná nemezerovým znakem.","trimEnd":"Zadejte řetězec, který končí nemezerovým znakem."},"__da":{"empty":"Angiv en gyldig streng.","max":"Angiv en streng, der indeholder %{value} eller færre tegn.","min":"Angiv en streng, der indeholder mindst %{value} tegn.","trimStart":"Angiv en streng, der begynder med et ikke-blanktegn.","trimEnd":"Angiv en streng, der slutter med et ikke-blanktegn."},"__de":{"empty":"Geben Sie eine gültige Zeichenfolge ein. ","max":"Geben Sie eine Zeichenfolge mit maximal %{value} Zeichen ein. ","min":"Geben Sie eine Zeichenfolge mit mindestens %{value} Zeichen ein. ","trimStart":"Geben Sie eine Zeichenfolge ein, die nicht mit einem Leerzeichen beginnt. ","trimEnd":"Geben Sie eine Zeichenfolge ein, die nicht mit einem Leerzeichen endet. "},"__es":{"empty":"Escriba una serie válida. ","max":"Escriba una serie que contenga %{value} o menos caracteres. ","min":"Escriba una serie que contenga al menos %{value} caracteres. ","trimStart":"Escriba una serie que comience con un carácter que no sea un espacio en blanco. ","trimEnd":"Escriba una serie que acabe con un carácter que no sea un espacio en blanco. "},"__fi":{"empty":"Anna kelvollinen merkkijono.","max":"Anna merkkijono, jossa on enintään %{value} merkkiä.","min":"Anna merkkijono, jossa on vähintään %{value} merkkiä.","trimStart":"Anna merkkijono, joka alkaa muulla kuin tyhjämerkillä.","trimEnd":"Anna merkkijono, joka päättyy muuhun kuin tyhjämerkkiin."},"__fr":{"empty":"Entrez une chaîne valide.","max":"Entrez une chaîne de %{value} caractères ou moins.","min":"Entrez une chaîne d'au moins %{value} caractères.","trimStart":"Entrez une chaîne commençant par un caractère différent d'un espace.","trimEnd":"Entrez une chaîne se terminant par un caractère différent d'un espace."},"__hr":{"empty":"Molim, unesite važeći niz znakova.","max":"Unesite niz koji sadrži %{value} ili manje znakova.","min":"Unesite niz koji sadrži najmanje %{value} znakova.","trimStart":"Unesite niz znakova koji počinje s nepraznim znakom.","trimEnd":"Unesite niz koji završava s nepraznim znakom."},"__hu":{"empty":"Adjon meg egy érvényes karaktersorozatot. ","max":"Adjon meg egy legfeljebb %{value} karaktert tartalmazó karaktersorozatot. ","min":"Adjon meg egy legalább %{value} karaktert tartalmazó karaktersorozatot. ","trimStart":"Adjon meg egy nem szóköz karakterrel kezdődő karaktersorozatot. ","trimEnd":"Adjon meg egy nem szóköz karakterrel végződő karaktersorozatot. "},"__it":{"empty":"Immettere una stringa valida.","max":"Immettere una stringa che non contenga più di %{value} caratteri. ","min":"Immettere una stringa che contenga almeno %{value}.","trimStart":"Immettere una stringa che non inizi con un carattere vuoto.","trimEnd":"Immettere una stringa che non termini con un carattere vuoto."},"__ja":{"empty":"有効な文字列を入力してください。","max":"文字数が %{value} 以内の文字列を入力してください。","min":"文字数が %{value} 以上の文字列を入力してください。","trimStart":"空白文字以外で始まる文字列を入力してください。","trimEnd":"空白文字以外で終わる文字列を入力してください。"},"__kk":{"empty":"Жарамды жолды енгізіңіз.","max":"%{value} немесе одан аз таңбалардан тұратын жолды енгізіңіз.","min":"Кемінде %{value} таңбаларынан тұратын жолды енгізіңіз.","trimStart":"Бос емес таңбадан басталатын жолды енгізіңіз.","trimEnd":"Бос емес таңбамен аяқталатын жолды енгізіңіз."},"__ko":{"empty":"올바른 문자열을 입력하십시오.","max":"%{value}자 이하의 문자가 포함된 문자열을 입력하십시오.","min":"%{value}자 이상의 문자가 포함된 문자열을 입력하십시오.","trimStart":"공백이 아닌 문자로 시작하는 문자열을 입력하십시오.","trimEnd":"공백이 아닌 문자로 끝나는 문자열을 입력하십시오."},"__nb":{"empty":"Oppgi en gyldig streng.","max":"Oppgi en streng som inneholder %{value} eller færre tegn.","min":"Oppgi en streng som inneholder minst %{value} tegn.","trimStart":"Oppgi en streng som begynner med et tegn som ikke er et blanktegn.","trimEnd":"Oppgi en streng som slutter med et tegn som ikke er et blanktegn."},"__nl":{"empty":"Geef een geldige tekenreeks op.","max":"Geef een tekenreeks op die %{value} of minder tekens bevat.","min":"Geef een tekenreeks op die ten minste %{value} tekens bevat.","trimStart":"Geef een tekenreeks op die niet begint met een teken voor witruimte.","trimEnd":"Geef een tekenreeks op die niet eindigt met een teken voor witruimte."},"__no":{"empty":"Oppgi en gyldig streng.","max":"Oppgi en streng som inneholder %{value} eller færre tegn.","min":"Oppgi en streng som inneholder minst %{value} tegn.","trimStart":"Oppgi en streng som begynner med et tegn som ikke er et blanktegn.","trimEnd":"Oppgi en streng som slutter med et tegn som ikke er et blanktegn."},"__pl":{"empty":"Wprowadź poprawny łańcuch.","max":"Wprowadź łańcuch zawierający nie więcej niż %{value} znaków.","min":"Wprowadź łańcuch zawierający co najmniej %{value} znaków.","trimStart":"Wprowadź łańcuch, który rozpoczyna się od znaku innego niż biały znak.","trimEnd":"Wprowadź łańcuch, który kończy się znakiem innym niż biały znak."},"__pt":{"empty":"Insira uma sequência válida.","max":"Insira uma sequência que contenha %{value} caracteres ou menos.","min":"Insira uma sequência que contenha ao menos %{value} caracteres.","trimStart":"Insira uma sequência que comece com um caractere diferente de um espaço em branco.","trimEnd":"Insira uma sequência que termine com um caractere diferente de um espaço em branco."},"__pt-br":{"empty":"Insira uma sequência válida.","max":"Insira uma sequência que contenha %{value} caracteres ou menos.","min":"Insira uma sequência que contenha ao menos %{value} caracteres.","trimStart":"Insira uma sequência que comece com um caractere diferente de um espaço em branco.","trimEnd":"Insira uma sequência que termine com um caractere diferente de um espaço em branco."},"__ro":{"empty":"Vă rugăm introduceţi un şir valid. ","max":"Introduceţi un şir care conţine %{value} caractere sau mai puţine. ","min":"Introduceţi un şir care conţine cel puţin %{value} caractere. ","trimStart":"Introduceţi un şir care începe cu un caracter care nu este blanc. ","trimEnd":"Introduceţi un şir care se termină cu un caracter care nu este blanc. "},"__ru":{"empty":"Введите допустимую строку символов.","max":"Веедите строку, содержащую %{value} или меньше символов.","min":"Веедите строку, содержащую как минимум %{value} символов.","trimStart":"Веедите строку символов, не начинающуюся с пробела.","trimEnd":"Веедите строку символов, не заканчивающуюся пробелом."},"__sl":{"empty":"Vnesite veljaven niz.","max":"Vnesite niz, ki vsebuje toliko znakov ali manj: %{value}.","min":"Vnesite niz, ki vsebuje vsaj toliko znakov: %{value}.","trimStart":"Vnesite niz, ki se začne z znakom, ki ni presledek.","trimEnd":"Vnesite niz, ki se konča z znakom, ki ni presledek."},"__sv":{"empty":"Ange en giltig sträng.","max":"Ange en sträng som innehåller högst %{value} tecken.","min":"Ange en sträng som innehåller minst %{value} tecken.","trimStart":"Ange en sträng som börjar med ett tecken som inte är osynligt.","trimEnd":"Ange en sträng som slutar med ett tecken som inte är osynligt."},"__th":{"empty":"โปรดป้อนสตริงที่ถูกต้อง","max":"ป้อนสตริงที่มี %{value} อักขระหรือน้อยกว่า","min":"ป้อนสตริงที่มีอย่างน้อย %{value} อักขระ","trimStart":"ป้อนสตริงที่ขึ้นต้นด้วยอักขระที่ไม่ใช่ whitespace","trimEnd":"ป้อนสตริงที่ลงท้ายด้วยอักขระที่ไม่ใช่ whitespace"},"__tr":{"empty":"Lüfen geçerli bir dizgi girin. ","max":"%{value} ya da daha az karakter içeren bir dizgi girin. ","min":"En az %{value} karakter içeren bir dizgi girin. ","trimStart":"Boşluk olmayan karakteri ile başlayan bir dizgi girin. ","trimEnd":"Boşluk olmayan karakteri ile biten bir dizgi girin. "},"__zh":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-cn":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-hk":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"},"__zh-mo":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"},"__zh-sg":{"empty":"请输入有效字符串。","max":"请输入包含 %{value} 或更少字符的字符串。","min":"请输入至少包含 %{value} 字符的字符串。","trimStart":"请输入不以空格字符开头的字符串。","trimEnd":"请输入不以空格字符结尾的字符串。"},"__zh-tw":{"empty":"請輸入有效字串。","max":"輸入包含 %{value} 或較少字元的字串。","min":"輸入至少包含 %{value} 個字元的字串。","trimStart":"輸入以非空格字元為開頭的字串。","trimEnd":"輸入以非空格字元為結尾的字串。"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(528);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "\n", ""]);

// exports
exports.locals = {
	"textInputClassName": "\"ba-common-textInput\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[522,0]]]);
});